// extracted by mini-css-extract-plugin
module.exports = {"groupContainer":"_1j2cb5ZR","header":"_2Peef6T3","counters":"_1UFj6w43","counterWrapper":"_2PqEGWm-","footer":"aSUuBQbF"};